import React, { useEffect } from 'react';
import { Dropdown, Grid, Icon, Popup, List, Radio, Button, Menu, Label, Loader } from 'semantic-ui-react';
import { Link, withRouter } from 'react-router-dom';
import axios from 'axios';
import { FormattedMessage } from 'react-intl';
import { IntlConsumer } from '../../IntlContext';
import moment from 'moment';
import { FiltersOnStyle } from '../../views/Professor/ProfessorInputGrades/css';
import ReactCountryFlag from 'react-country-flag';
import { toast, ToastContainer } from 'react-toastify';

axios.defaults.xsrfHeaderName = 'X-XSRF-TOKEN';
axios.defaults.xsrfCookieName = 'XSRF-TOKEN';
axios.defaults.withCredentials = true;
// axios.defaults.crossDomain = true;

window.$setLanguageFirstTime = false;


class Header extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            activeRole: this.props.activeRole,
            allRoles: [],
            newNotifications: [],

            // notification
            seen: true,
            showNotificationNumber: true,
            allNotificationButton: true,


            // web push
            // denied: Notification.permission === 'denied',
            subscribed: false,
            publicKey: '',
        };
        // this.urlB64ToUint8Array = this.urlB64ToUint8Array.bind(this);
        // this.subscribe = this.subscribe.bind(this);
        // this.unsubscribe = this.unsubscribe.bind(this);
        this.markAllAsRead = this.markAllAsRead.bind(this);
        this.fetchNewNotification = this.fetchNewNotification.bind(this);
        this.fetchAllRoles = this.fetchAllRoles.bind(this);
    }


    componentDidMount() {
        // this.fetchActiveRole();
        this.fetchAllRoles();
        this.fetchNewNotification();
        // this.subscribe();
    }


    fetchNewNotification() {
        this.setState({ loading: true });
        axios.get('/notifications/user/')
            .then(res => {
                const newNotifications = res.data.reverse();

                this.setState({ newNotifications, loading: false });
                // localStorage.setItem('newNotifications', JSON.stringify(newNotifications));
            })
            .catch(err => {
                console.log('Failed to fetch new notifications.');
            });
    }

    // unsubscribe() {
    //     navigator.serviceWorker.getRegistration()
    //         .then((registration)=>{
    //             registration.pushManager.getSubscription()
    //                 .then((subscription)=>{
    //                     subscription.unsubscribe()
    //                         .then(()=> {
    //                             axios.post('/notifications/unsubscribe', JSON.stringify(subscription.endpoint))
    //                                 .then(response => {
    //                                     this.setState({ subscribed: false });
    //                                 })
    //                         })
    //                 })
    //                 .catch((err)=> {
    //                     console.log('Unsubscribe failed. No subscription. ', err)
    //                 })
    //         })
    //         .catch((err)=> {
    //             console.log('No sw registration. ', err)
    //     })
    // }

    // subscribe() {
    //     Notification.requestPermission()
    //         .then(notificationPermission => {
    //             if (notificationPermission === 'granted') {
    //                 navigator.serviceWorker.getRegistration()
    //                     .then((registration) => {
    //                         registration.pushManager.getSubscription()
    //                             .then((subscription)=>{
    //                                 console.log('Provjera da li postoji subskripcija vec ', subscription);
    //                                 if (subscription === null){
    //                                     this.getPublicKey().then((publicKey)=>
    //                                         {
    //                                             this.setState({ publicKey},
    //                                                 ()=> {
    //                                                     registration.pushManager.subscribe({
    //                                                         userVisibleOnly: true,
    //                                                         applicationServerKey: this.urlB64ToUint8Array(publicKey), })
    //                                                         .then(subscription => {
    //                                                             const subJSObject = JSON.parse(JSON.stringify(subscription));
    //
    //                                                             axios.post('/notifications/subscribe', {endpoint: subscription.endpoint, keys: subJSObject.keys})
    //                                                                 .then(response => {
    //                                                                     this.setState({ subscribed: true });
    //                                                                 })
    //                                                         }, (err) => {
    //                                                             console.log('Subscription failed. ', err);
    //                                                         })
    //
    //                                                 })
    //
    //                                         }
    //                                     )
    //                                 } else {
    //                                     const subJSObject = JSON.parse(JSON.stringify(subscription));
    //                                     axios.post('/notifications/subscribe', {endpoint: subscription.endpoint, keys: subJSObject.keys})
    //                                         .then(response => {
    //                                             this.setState({ subscribed: true });
    //                                         })
    //                                 }
    //                                 this.setState({ subscribed: subscription });
    //                             })
    //
    //                 }, (err) => {
    //                     console.log('No sw registration. ', err);
    //                 });
    //             } else {
    //                 console.log('Permission denied! ');
    //                 this.setState({ denied: true });
    //             }
    //         });
    //
    // }

    // getPublicKey = () => axios.get('/notifications/get-public-key').then(response => response.data).catch(error => {console.error('Failed to fetch public key!');});

    // urlB64ToUint8Array(base64String) {
    //     const padding = '='.repeat((4 - (base64String.length % 4)) % 4);
    //     const base64 = (base64String + padding)
    //         .replace(/\-/g, '+')
    //         .replace(/_/g, '/');
    //     const rawData = window.atob(base64);
    //     const outputArray = new Uint8Array(rawData.length);
    //     for (let i = 0; i < rawData.length; ++i) {
    //         outputArray[i] = rawData.charCodeAt(i);
    //     }
    //     return outputArray;
    // }

    // sendNotification(){
    //     navigator.serviceWorker.getRegistration().then((res) => {
    //         res.showNotification('Uspješno ste omogućili obavijesti na svom profilu.')
    //     })
    // }

    fetchActiveRole() {
        localStorage.remove('activeRole');
        axios.get('/user/current')
            .then(response => {
                this.setState({ activeRole: response.data });
                localStorage.setItem('activeRole', response.data);
            }).catch(error => {
            // TODO amel: error handling
                console.error('Failed to fetch active userrole');
            });
    }

    markAllAsRead() {
        this.setState({ loading: true });
        axios.put('notifications/mark-all-as-read/')
            .then(res => {
                this.fetchNewNotification();
            }).then(() => {
                this.setState({ loading: false });
            })
            .catch(err => {
                toast('Došlo je do greške!');
            });
    }

    fetchAllRoles() {
        axios.get('/user/all')
            .then(response => {
                this.setState({ allRoles: response.data });
            }).catch(error => {
                // TODO amel: error handling
                console.error('Failed to fetch user roles');
            });
    }

    sidebarToggle(e) {
        e.preventDefault();
        document.body.classList.toggle('sidebar-hidden');
    }

    sidebarMinimize(e) {
        e.preventDefault();
        document.body.classList.toggle('sidebar-minimized');
    }

    mobileSidebarToggle(e) {
        e.preventDefault();
        document.body.classList.toggle('sidebar-mobile-show');
    }

    asideToggle(e) {
        e.preventDefault();
        document.body.classList.toggle('aside-menu-hidden');
    }
    render() {
        return (
            <header className={window.location.href.includes('dev1.eunsa.ba') ? 'app-header navbar dev' : 'app-header navbar prod'} style={{ position: 'fixed' }}>


                {/* <Radio toggle checked={this.state.subscribed}   onChange={this.toggle} /> */}
                <button className="navbar-toggler mobile-sidebar-toggler d-lg-none" style={{ color: 'white', outline: 'none' }} onClick={this.mobileSidebarToggle} type="button">
                    &#9776;
                </button>

                <a className="navbar-brand d-md-down-none" href="/" />
                <a className="navbar-brand d-lg-none" href="/" />

                <ul className="nav navbar-nav d-md-down-none mr-auto">
                    <li className="nav-item">
                        <a className="nav-link navbar-toggler sidebar-toggler" onClick={this.sidebarToggle} style={{ color: 'white' }} href="/">&#9776;</a>
                    </li>
                </ul>


                <div style={{ float: 'right', right: '1%' }}>
                    <Grid columns={3} padded >
                        <Grid.Column only="computer">
                            {
                                (this.props.activeRole.substr(0, 8) === 'Student:' ||
                                    this.props.activeRole.substr(0, 10) === 'Studentska' ||
                                    this.props.activeRole.substr(0, 8) === 'Profesor' ||
                                    this.props.activeRole.substr(0, 8) === 'Asistent')
                                    ?


                                        <Popup
                                        only="computer"
                                        size="mini"
                                        hideOnScroll={this.state.newNotifications.filter((e) => !e.seen).length === 0}
                                        flowing
                                        onClose={() => this.setState({ showNotificationNumber: true })}
                                        onOpen={() => { this.setState({ showNotificationNumber: false }); }}
                                        trigger={

                                            <div style={{ float: 'left', cursor: 'pointer' }}>


                                                {this.state.newNotifications.filter((e) => !e.seen).length !== 0 && this.state.showNotificationNumber
                                                    ?

                                                        <Icon.Group size="large">
                                                        <Icon name="bell" color="grey" />
                                                        <Label color="red" floating size="tiny" circular>
                                                                {this.state.newNotifications.filter((e) => !e.seen).length > 99 ? '99+' : this.state.newNotifications.filter((e) => !e.seen).length }
                                                            </Label>
                                                    </Icon.Group>
                                                    :
                                                    <Icon.Group size="large">
                                                            <Icon name="bell" color="grey" />
                                                            <Icon corner="bottom right" circular as="label"></Icon>
                                                        </Icon.Group>
                                                    // <Icon size="large" name="bell" color="grey" />
                                                }

                                            </div>
                                        }

                                        content={<Link to={{ pathname: '/obavijesti' }} style={{ color: 'black' }}>

                                            <div style={{
                                                maxWidth: '20vw', width: '20vw', maxHeight: '500px', overflow: 'auto'
                                            }}
                                            > {this.state.newNotifications.filter((e) => !e.seen).length === 0 ?
                                                <div >
                                                        <h5><FormattedMessage id="common.noNewNotifications" /></h5>
                                                        {window.location.pathname !== '/obavijesti' && <Button basic fluid color="blue" content="Sve obavijesti" style={FiltersOnStyle} />}

                                                    </div> :
                                                    <div>

                                                    <Label basic as="a" onClick={(e) => { e.preventDefault(); this.markAllAsRead(); }}>
                                                            {this.state.loading ? <Loader size="tiny" active inline="centred" /> :

                                                                <span>
                                                                <Icon name="mail" />
                                                                {this.state.newNotifications.filter((e) => !e.seen).length > 99 ? '99+' : this.state.newNotifications.filter((e) => !e.seen).length }
                                                            </span>

                                                            }

                                                            <Label.Detail>Označi sve kao pročitano</Label.Detail>
                                                        </Label>
                                                    <Menu size="mini" vertical fluid divided relaxed style={{ marginBottom: '12px' }}>
                                                            {this.state.newNotifications.map((el, index) =>
                                                                (!el.seen && <Menu.Item>
                                                                    <List.Content>
                                                                        <List.Header as="h4" style={{ color: '#1a6aa5' }}>
                                                                            {el.notification ? el.notification.subject : 'Nema teksta.'}
                                                                        </List.Header>

                                                                        <List.Description as="h6" style={{ color: 'gray' }}>
                                                                            <Icon color="teal" name="user" />
                                                                &nbsp;
                                                                            {

                                                                                el.notification && el.notification.sender ?
                                                                                    el.notification.sender.employee.person.lastName + ' ' + el.notification.sender.employee.person.firstName + '    '
                                                                                    : 'eUNSA '
                                                                            }
                                                                &nbsp;
                                                                            <Icon color="teal" name="calendar alternate outline" />
                                                                &nbsp;
                                                                            {

                                                                                moment(el.notification && el.notification.timestamp).calendar(null, window.$locale === 'bs' ? {
                                                                                    sameDay: '[danas u] LT',
                                                                                    nextDay: '[sutra u] LT',
                                                                                    nextWeek: 'D. M. YYYY. [u] LT',
                                                                                    lastDay: '[jučer u] LT',
                                                                                    lastWeek: 'D. M. YYYY. [u] LT',
                                                                                    sameElse: 'D. M. YYYY. [u] LT'
                                                                                } : {
                                                                                    lastDay: '[Yesterday at] LT',
                                                                                    sameDay: '[Today at] LT',
                                                                                    nextDay: '[Tomorrow at] LT',
                                                                                    lastWeek: 'D. M. YYYY. [at] LT',
                                                                                    nextWeek: 'D. M. YYYY. [at] LT',
                                                                                    sameElse: 'D. M. YYYY. [at] LT'
                                                                                })
                                                                            }
                                                                        </List.Description>

                                                                        { index === this.state.answerIndex && <List.Description style={{
                                                                            textAlign: 'justify', textJustify: 'inter-word', color: '#000000', paddingRight: '15px'
                                                                        }}
                                                                        > <br />{el.notification && el.notification.text}
                                                                        </List.Description>}
                                                                    </List.Content>
                                                                </Menu.Item>))}
                                                        </Menu>

                                                </div>

                                                }

                                            </div>

                                        </Link>}
                                        position="bottom right"
                                        on="click"
                                    /> : <p />
                            }
                        </Grid.Column>

                        {(this.props.activeRole.substr(0, 8) === 'Student:' ||
                            this.props.activeRole.substr(0, 8) === 'Profesor' ||
                            this.props.activeRole.substr(0, 8) === 'Asistent')

                        &&
                            <Grid.Column><IntlConsumer>
                                {({ switchToEnglish, switchToBosnian, switchToCroatian }) => (

                                    <React.Fragment>
                                        <Dropdown icon="grey large globe icon" direction="right" pointing="top right">
                                            <Dropdown.Menu>

                                                <Dropdown.Item onClick={(this.props.activeRole.includes('Katolički') || this.props.activeRole.includes('Integrirani filozofsko-teološki studij')) ? switchToCroatian : switchToBosnian} >
                                                    <Link to={{ pathname: '/' }} style={{ color: window.$locale === 'bs' ? '#1a6aa5' : 'black' }}>
                                                        <ReactCountryFlag countryCode="ba" svg style={{ marginBottom: '3px' }} /> B/H/S </Link>
                                                </Dropdown.Item >
                                                <Dropdown.Item onClick={switchToEnglish}>
                                                    <Link to={{ pathname: '/' }} style={{ color: window.$locale === 'en' ? '#1a6aa5' : 'black' }}>
                                                        <ReactCountryFlag countryCode="gb" svg style={{ marginBottom: '3px' }} /> EN </Link>
                                                </Dropdown.Item >
                                            </Dropdown.Menu>

                                        </Dropdown>
                                    </React.Fragment>

                                )}
                            </IntlConsumer></Grid.Column> }
                        <Grid.Column>
                            <Dropdown icon="grey large user icon" direction="right" pointing="top right">
                                <Dropdown.Menu>
                                    <Dropdown.Item text={this.props.activeRole} style={{ color: '#2c8bd3' }} />
                                    {this.state.allRoles.map((value, index) => {
                                        let el = <Dropdown.Item text={value} as={Link} to={'/u/' + index + '/'} target="_blank" style={{ display: 'block', height: '100%' }} />;
                                        if (index === 0) {
                                            return [<Dropdown.Divider />, el];
                                        }
                                        return el;
                                    })
                                    }
                                    <Dropdown.Divider />
                                    <Dropdown.Item style={{ color: '#2185d0', fontWeigh: 'bold' }} as="a" href={`${process.env.REACT_APP_EUNSA_KEYCLOAK_URL}/realms/isss/protocol/openid-connect/logout?redirect_uri=${process.env.REACT_APP_EUNSA_FRONTEND_URL}`}>
                                        <Button
                                            basic
                                            fluid
                                            color="blue"
                                            icon="refresh"
                                            style={FiltersOnStyle}
                                        ><FormattedMessage id="common.logout" /></Button>
                                    </Dropdown.Item >
                                </Dropdown.Menu>
                            </Dropdown>
                        </Grid.Column>


                    </Grid>
                </div>

                {/* <ToastContainer/> */}
            </header>
        );
    }
}

export default Header;



// WEBPACK FOOTER //
// ./src/components/Header/Header.js